import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDNXANVP7ZTOMfDRA7lFYZ5_fbKgjO_vjs",
  authDomain: "truelifeticketing.firebaseapp.com",
  projectId: "truelifeticketing",
  storageBucket: "truelifeticketing.firebasestorage.app",//
  messagingSenderId: "531317526349",
  appId: "1:531317526349:web:98bee1e483a90895963104"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { db, storage, app, auth };
